// extracted by mini-css-extract-plugin
module.exports = {"mapStyles":"MapContainer_mapStyles__2mNsv","sideSpan":"MapContainer_sideSpan__3rEb_","title":"MapContainer_title__1Z1PT"};